import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Loads platform organisations and renders a selector. For platform-admin scoped pages.
export function OrgSelect({ value, onChange, testId = "org-select" }) {
  const [orgs, setOrgs] = useState([]);
  useEffect(() => {
    api.get("/platform/organisations").then((r) => {
      setOrgs(r.data);
      if (!value && r.data.length) onChange(r.data[0].id);
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger className="w-[260px] bg-white" data-testid={testId}><SelectValue placeholder="Select organisation" /></SelectTrigger>
      <SelectContent>
        {orgs.map((o) => (
          <SelectItem key={o.id} value={o.id} data-testid={`org-opt-${o.id}`}>{o.name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

// Returns [orgId, setOrgId, isPlatform]. For platform admins, undefined until selected.
export function useOrgScope() {
  const { auth } = useAuth();
  const [orgId, setOrgId] = useState(auth?.is_platform_admin ? null : auth?.organisation?.id);
  return [orgId, setOrgId, auth?.is_platform_admin];
}
